const UserCircle = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0003 1.6665C5.39795 1.6665 1.66699 5.39746 1.66699 9.99984C1.66699 12.414 2.69359 14.5884 4.33405 16.1104C5.82094 17.4898 7.81214 18.3332 10.0003 18.3332C12.1885 18.3332 14.1797 17.4898 15.6666 16.1104C17.3071 14.5884 18.3337 12.414 18.3337 9.99984C18.3337 5.39746 14.6027 1.6665 10.0003 1.6665ZM4.98037 14.9972C6.08298 13.4781 7.84294 12.4998 10.0003 12.4998C12.1577 12.4998 13.9177 13.4781 15.0203 14.9972C13.7376 16.2857 11.9621 17.0832 10.0003 17.0832C8.03857 17.0832 6.26308 16.2857 4.98037 14.9972ZM12.5003 8.33317C12.5003 9.71388 11.381 10.8332 10.0003 10.8332C8.61961 10.8332 7.50033 9.71388 7.50033 8.33317C7.50033 6.95246 8.61961 5.83317 10.0003 5.83317C11.381 5.83317 12.5003 6.95246 12.5003 8.33317Z"
      fill="currentColor"
    />
  </svg>
)

export default UserCircle
